module.exports = __webpack_public_path__ + "static/family-hug-78614d7a5d2b0896d1bb050242cfff34.png";